// extracted by mini-css-extract-plugin
export default {"outerFlex":"AboutContent_outerFlex__F9efk","heading":"AboutContent_heading__469i8","innerFlex":"AboutContent_innerFlex__XQ9Nm","stoneBox":"AboutContent_stoneBox__KQ0ei"};